import clsx from 'clsx';
import { InputHTMLAttributes, useEffect, useState } from 'react';
import useFormat from '../../../hooks/useFormat';
import styles from './BetOdds.module.css';

type Props = InputHTMLAttributes<HTMLButtonElement> & {
  price?: number | null;
  label?: string;
  selected?: boolean;
  fixedWidth?: boolean;
};

export default function BetOdds({
  price,
  label,
  selected,
  fixedWidth = false,
  ...rest
}: Props) {
  const [displayPrice, setDisplayPrice] = useState(price);
  const [animation, setAnimation] = useState('');

  useEffect(() => {
    if (price && !displayPrice) setDisplayPrice(price);
    if (!displayPrice || !price) return;
    if (displayPrice > price) {
      setAnimation('firm');
    } else if (displayPrice < price) {
      setAnimation('drift');
    }

    setDisplayPrice(price);
  }, [price, displayPrice]);

  useEffect(() => {
    const animationTimer = setTimeout(() => {
      setAnimation('');
    }, 1500);

    return () => {
      clearTimeout(animationTimer);
    };
  }, [animation]);

  const format = useFormat();
  const displayLabel = label || '-';

  return (
    <>
      <span
        className={clsx(
          styles.container,
          {
            [styles.fixedWidth]: fixedWidth,
            [styles.selected]: selected,
          },
          styles[animation]
        )}
        {...rest}
      >
        {price ? format.odds(price) : displayLabel}
      </span>
    </>
  );
}
